import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { getCategoryMediaMock } from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { utilsPath } from '../../utils/paths';

export default {
  categoryMediaGet: (id, filters) => {
    if (shouldUseMock()) {
      return getCategoryMediaMock();
    }
    return apiCall(
      `${baseUrl}${utilsPath}category/${id}/gallery/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
};
